import { CatalogDetailState } from '@/redux/modules/catalogDetail/catalogDetail.types';
import { createSelector } from '@reduxjs/toolkit';
import { emptyCatalogDetail } from '@/types/CatalogDetail';
import { GlobalState } from '@/redux/rootReducer';

const stateSelector = (state: GlobalState): CatalogDetailState => state.catalogDetail;
const idSelector = (state: GlobalState, id: number) => id;

const byIdSelector = createSelector(stateSelector, (state) => state.byId);

const loadedSelector = createSelector(stateSelector, (state) => state.loaded);

const loadingSelector = createSelector(stateSelector, (state) => state.loading);

export const getCatalogDetail = createSelector(
    [byIdSelector, idSelector],
    (byId, id) => byId[id] || emptyCatalogDetail
);

export const getLoadTimeForCatalogDetail = createSelector(
    [loadedSelector, idSelector],
    (loaded, id) => loaded[id] || 0
);

export const isCatalogDetailLoading = createSelector([loadingSelector, idSelector], (loading, id) =>
    loading.includes(id)
);

export const getIsCatalogDetailLoaded = createSelector([loadedSelector, idSelector], (loaded, id) =>
    loaded.hasOwnProperty(id)
);

export const getCatalogDetailFreeLocalPickup = createSelector(getCatalogDetail, (catalogDetail) =>
    Boolean(catalogDetail?.freeLocalPickup)
);

export const getCatalogDetailContainsBuyNowItems = createSelector(getCatalogDetail, (catalogDetail) =>
    Boolean(catalogDetail?.containsBuyNowItems)
);

export const getCatalogDetailInHouseShipping = createSelector(getCatalogDetail, (catalogDetail) =>
    Boolean(catalogDetail?.inHouseShipping)
);

export const getCatalogDetailPaymentDetails = createSelector(
    getCatalogDetail,
    (catalogDetail) => catalogDetail?.paymentDetails || ''
);

export const getCatalogDetailShippingDetails = createSelector(
    getCatalogDetail,
    (catalogDetail) => catalogDetail?.shippingDetails || ''
);

export const getCatalogDetailExternalUrl = createSelector(
    getCatalogDetail,
    (catalogDetail) => catalogDetail?.externalUrl || ''
);

export const getCatalogDetailTerms = createSelector(getCatalogDetail, (catalogDetail) => catalogDetail?.terms || '');
export const getCatalogDetailCustomTerms = createSelector(
    getCatalogDetail,
    (catalogDetail) => catalogDetail?.customTerms || []
);
